import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Backend serves /media on its own origin; make root-relative media URLs
// absolute so <video> playback works from the frontend origin too.
export function mediaUrl(u) {
  if (u && u.startsWith("/media/")) return BACKEND_URL + u;
  return u;
}

export const http = axios.create({ baseURL: API, withCredentials: true });

// Portals share one origin (localhost / subdomain-less dev preview), so a
// single shared token key would let one portal's login clobber another's.
// Namespace the stored token per portal; the cab player (`/cab/:plate`) is
// public and sends none.
export function currentPortal() {
  const seg = (window.location.pathname.split("/")[1] || "").toLowerCase();
  if (seg === "cab") return null;
  if (["ops", "business", "partner"].includes(seg)) return seg;
  return "ops";
}
const tokenKey = (portal) => (portal ? `anand_token_${portal}` : null);

export function setToken(t, portal) {
  const p = portal === undefined ? currentPortal() : portal;
  const k = tokenKey(p);
  if (!k) return;
  if (t) localStorage.setItem(k, t);
  else localStorage.removeItem(k);
}
export function loadToken(portal) {
  const p = portal === undefined ? currentPortal() : portal;
  const k = tokenKey(p);
  if (k) {
    const direct = localStorage.getItem(k);
    if (direct) return direct;
  }
  // Legacy single-key token (pre-namespacing); used only for migration.
  return localStorage.getItem("anand_token");
}
http.interceptors.request.use((config) => {
  const p = currentPortal();
  if (p && loadToken(p)) config.headers.Authorization = `Bearer ${loadToken(p)}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export function downloadCSV(filename, rows) {
  const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
